import { useDialogStore } from '@/store';

export function useConfirmation() {
	const setDialog = useDialogStore((s) => s.setStore);
	const setAction = useDialogStore((s) => s.setAction);
	const onOpen = useDialogStore((s) => s.onOpenChange);

	function askCloseIfDirty(
		isDirty: boolean,
		preventDefault: () => void,
		next: () => void
	) {
		preventDefault();

		if (isDirty) {
			setDialog('variant', 'warning');
			setDialog('title', 'Yakin akan keluar?');
			setDialog(
				'description',
				'Proses unggah dokumen akan tidak tersimpan apabila Anda keluar'
			);
			setDialog('confirmText', 'Ya, Keluar');
			setDialog('cancelText', 'Batal');
			setAction('onConfirm', next);
			setDialog('open', true);
			return;
		}

		next();
	}

	function askConfirmDeleteDocument(next: () => void) {
		setDialog('variant', 'warning');
		setDialog('title', 'Hapus Dokumen?');
		setDialog('description', 'Apakah Anda yakin ingin menghapus dokumen?');
		setDialog('confirmText', 'Ya, Hapus');
		setDialog('cancelText', 'Batal');
		setAction('onConfirm', next);
		onOpen(true);
	}

	return {
		askCloseIfDirty,
		askConfirmDeleteDocument
	};
}
